// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"eeb7474e","453":"bf990ce8"}[chunkId] + ".chunk.js";
};